import { Injectable } from "@angular/core";
import { CachedStore, searchSourceFactory } from "@fry-it/risr-core";
import { Report, PublicApiReport, ReportApiMetadata, ReportMetadata } from "../models/report";
import { ApiSearchReport, SearchReport } from "../models/search_report";


@Injectable({
    providedIn: 'root'
})
export class ReportStore extends CachedStore<PublicApiReport, Report> {
    prefix = 'reports';

    searchSource = searchSourceFactory<SearchReport, ApiSearchReport>(`/${this.prefix}/search`, {
        api: this.api,
        instantiate: (item) => SearchReport.fromApiResponse(item)
    });

    public async getAll(): Promise<Report[]> {
        const reports = await this.fetchAll();
        return reports.map(this.fromApiResponse);
    }

    protected fetchOne(key: string): Promise<PublicApiReport> {
        return this.api.get<PublicApiReport>(`/reports/${key}`);
    }

    protected fetchAll(): Promise<PublicApiReport[]> {
        return this.api.get<PublicApiReport[]>(`/reports/`);
    }

    protected fromApiResponse(response: PublicApiReport): Report {
        return Report.fromApiResponse(response);
    }

    /**
     * Return latest available report from a group
     */
    public async getByGroup(groupId: string): Promise<Report> {
        const report = await this.api.get<PublicApiReport>(`/reports/by_group_id/${groupId}`);
        return this.fromApiResponse(report);
    }

    public async getMetadataFor(id: string, forUser: string): Promise<ReportMetadata> {
        const metadata = await this.api.get<ReportApiMetadata>(`/reports/${id}/metadata/${forUser}`);
        return {
            canNavigateTo: metadata.can_navigate_to
        };
    }
}